<template>
  <v-container class="mensch-page">
    <div>
      <div class="bg-fixed-100" :style="{ backgroundImage: 'url(' + aboutBg + ')' }"></div>

      <router-link :to="{ name: 'Home'}">
      <img :src="$root.logo" class="main-logo big relative ">
    </router-link>

      <div class="content">
        <iconClose @click="onClose" class="icon-close"></iconClose>
        <v-container>
          <v-row>
            <v-col cols="12" md="4"><img src="/static/images/inspiration/IMG_0558.jpg"></v-col>
            <v-col cols="12" md="4"><img src="/static/images/inspiration/IMG_0559.jpg"></v-col>
            <v-col cols="12" md="4"><img src="/static/images/inspiration/IMG_0560.jpg"></v-col>
            <v-col cols="12" md="4"><img src="/static/images/inspiration/IMG_0558.jpg"></v-col>
            <v-col cols="12" md="4"><img src="/static/images/inspiration/IMG_0559.jpg"></v-col>
            <v-col cols="12" md="4"><img src="/static/images/inspiration/IMG_0560.jpg"></v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </v-container>
</template>

<script>
import Viewport from '@monogrid/vue-lib/lib/mixins/Viewport'
import aboutBg from '@/assets/img/mensch-bg.jpg'
import iconClose from '@/assets/svg/cross-icon.svg'
import aboutTexture from '@/assets/img/about-texture.jpg'

export default {
  name: 'Mensch',

  mixins: [Viewport],

  components: {
    iconClose
  },
  data () {
    return {
      aboutBg,
      aboutTexture
    }
  },

  methods: {
    onClose () {
      this.$router.push({ name: 'Home' })
    }
  },

  watch: {
  },

  metaInfo: function () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.mensch-page {
  text-align: center;
}

.icon-close {
  float: right;
  background-color: #fff;
  border-radius: 50px;
  padding: 15px;
  width: 60px;
  height: 60px;
}

.content {
  background-size: cover;
  position: relative;
  width: 100%;
  padding: 40px;
  margin: auto;

  @include breakpoint('xs-only') {
    padding: 0;
  }

  p {
    margin-top: 60px;
    font-size: 20px;
    line-height: 40px;
  }

  img {
    width: 100%;
  }
}

.home-title {
  position: relative;
  margin-top: 10%;
  padding: 10px 40px;
  color: $c-red;
  text-align: center;

  h1,
  h4 {
    font-weight: 500;
  }

  h1 {
    margin-top: -40px;

    @include breakpoint('xs-only') {
      margin-top: 0;
    }
  }
}

</style>
